export default __webpack_public_path__ + "static/media/notification.aec3383b.svg";